module.exports = "pegasus/assets/test-fixture-cat.png";